export default __webpack_public_path__ + "wp-content/uploads/react/user-dashboard/media/icomoon.829e1a11.svg";